var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreventsRisks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_7720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3199 156.705C66.914 147.29 57.6101 137.977 48.2328 128.591C48.2124 128.685 48.2002 128.558 48.2573 128.501C52.8073 124.059 57.2717 119.531 61.9441 115.22C65.6297 111.817 70.139 110.218 75.1823 110.218C78.8436 110.218 82.5089 110.312 86.166 110.194C90.7364 110.047 94.944 111.108 98.756 113.6C100.53 114.763 102.364 115.162 104.48 115.142C113.075 115.052 121.669 115.085 130.264 115.122C133.966 115.138 137.048 117.496 138.149 120.983C139.225 124.402 138.043 128.045 135.136 130.227C133.481 131.467 131.589 131.912 129.55 131.912C122.024 131.899 114.498 131.908 106.971 131.912C106.515 131.912 106.054 131.903 105.597 131.924C104.505 131.977 103.877 132.605 103.824 133.645C103.771 134.702 104.403 135.367 105.442 135.53C106.038 135.624 106.662 135.571 107.269 135.571C114.693 135.571 122.118 135.583 129.542 135.571C136.75 135.558 141.716 130.847 142.206 123.663C142.246 123.08 142.613 122.427 143.021 121.983C148.036 116.504 153.079 111.055 158.127 105.605C160.675 102.856 163.737 102.578 166.513 104.822C169.351 107.114 169.799 110.312 167.622 113.323C160.862 122.68 154.098 132.034 147.286 141.351C145.818 143.358 144.305 145.373 142.536 147.098C138.377 151.153 133.264 153.013 127.467 153.013C113.633 153.013 99.8039 153.05 85.9703 152.989C82.2194 152.972 78.9577 153.947 76.3158 156.705H76.3199Z",
    fill: "url(#paint0_linear_64_7720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.224 102.113C102.372 102.113 93.521 102.15 84.6696 102.105C76.6826 102.064 70.6689 96.9653 69.3398 89.1333C68.7079 85.4171 69.6415 81.9947 71.521 78.7558C79.0147 65.8248 86.4717 52.8693 93.9409 39.9219C95.3394 37.4989 96.7133 35.0636 98.1485 32.665C104.195 22.5405 118.399 22.3936 124.368 32.5508C133.509 48.1129 142.536 63.7444 151.436 79.4452C157.246 89.6921 150.054 101.938 138.238 102.093C129.236 102.211 120.23 102.117 111.228 102.117L111.224 102.113ZM111.322 95.5213C120.067 95.5213 128.816 95.5661 137.562 95.509C145.133 95.456 149.075 88.6193 145.32 82.0926C136.575 66.8935 127.813 51.7026 119.023 36.528C115.236 29.9891 107.387 30.0176 103.567 36.5566C101.284 40.4604 99.0414 44.3886 96.7786 48.3087C90.3042 59.5347 83.842 70.7728 77.339 81.9824C76.0833 84.1444 75.4758 86.3798 76.0588 88.8396C77.0618 93.0574 80.4172 95.505 85.2323 95.5172C93.9287 95.5376 102.625 95.5213 111.322 95.5213Z",
    fill: "url(#paint1_linear_64_7720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 140.311C33.9995 136.325 38.0685 132.27 42.0559 128.297C53.5777 139.858 65.1566 151.471 76.6255 162.979C72.74 166.866 68.6629 170.949 64.6144 175C53.1659 163.529 41.5666 151.904 29.9958 140.311H29.9999Z",
    fill: "url(#paint2_linear_64_7720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.183 91.8581C102.486 91.8581 93.79 91.8704 85.0936 91.85C81.4528 91.8418 79.1696 89.5697 79.5651 86.3227C79.6589 85.5435 80.0013 84.7522 80.3968 84.0628C89.1911 68.774 98.0017 53.4933 106.833 38.2249C109.104 34.3007 113.539 34.3456 115.823 38.2943C124.601 53.477 133.362 68.6638 142.116 83.8629C144.517 88.0318 142.283 91.8377 137.423 91.85C128.674 91.8744 119.928 91.8581 111.179 91.8581H111.183ZM109.466 62.3085C109.466 65.8737 109.458 69.4348 109.466 73C109.47 74.6521 110.086 75.4557 111.301 75.4557C112.512 75.4557 113.124 74.648 113.124 72.9919C113.132 65.8655 113.132 58.7392 113.124 51.6128C113.124 49.9567 112.508 49.1572 111.289 49.1612C110.074 49.1612 109.466 49.9648 109.462 51.6251C109.454 55.1903 109.462 58.7514 109.462 62.3166L109.466 62.3085ZM109.45 81.4521C109.483 82.5861 109.968 83.4264 111.183 83.508C112.402 83.5896 113.054 82.8431 113.111 81.6683C113.168 80.5139 112.642 79.6613 111.415 79.592C110.213 79.5227 109.593 80.261 109.45 81.4521Z",
    fill: "url(#paint3_linear_64_7720)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_7720",
    x1: 108.605,
    y1: 103.32,
    x2: 108.605,
    y2: 156.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_7720",
    x1: 111.316,
    y1: 25.002,
    x2: 111.316,
    y2: 102.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_64_7720",
    x1: 53.3107,
    y1: 128.297,
    x2: 53.3107,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_64_7720",
    x1: 111.304,
    y1: 35.3071,
    x2: 111.304,
    y2: 91.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_7720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 150,
    fill: "white",
    transform: "translate(30 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventsRisks);
export default __webpack_public_path__ + "static/media/Prevents_risks.aee993951e45d67167efb08acf1b5e39.svg";
export { ForwardRef as ReactComponent };